import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/search-directory/Main.css";

const sampleData = [
  {
    usergroup: "Example Org",
    organization: "",
    projectaddress: "",
    projectphone: "",
    projectfax: "",
  },
  {
    usergroup: "Example Org",
    organization: "",
    projectaddress: "",
    projectphone: "",
    projectfax: "",
  },
  {
    usergroup: "Example Org",
    organization: "",
    projectaddress: "",
    projectphone: "",
    projectfax: "",
  },
  {
    usergroup: "Example Org",
    organization: "",
    projectaddress: "",
    projectphone: "",
    projectfax: "",
  },
  {
    usergroup: "Example Org",
    organization: "",
    projectaddress: "",
    projectphone: "",
    projectfax: "",
  },
  {
    usergroup: "Example Org",
    organization: "",
    projectaddress: "",
    projectphone: "",
    projectfax: "",
  },
  {
    usergroup: "Example Org",
    organization: "",
    projectaddress: "",
    projectphone: "",
    projectfax: "",
  },
  {
    usergroup: "Example Org",
    organization: "",
    projectaddress: "",
    projectphone: "",
    projectfax: "",
  },
  {
    usergroup: "Example Org",
    organization: "",
    projectaddress: "",
    projectphone: "",
    projectfax: "",
  },

  // Add more objects here
];

const headers = [
  "User/Group",
  "Organization",
  "Project address",
  "Project Phone",
  "Project Fax",
];

const Main = () => {
  const navigate = useNavigate();

  return (
    <div className="search-directory">
      <div className="search-directory-header">
        <div className="title">
          <div className="directory">Search Directory</div>
          <div className="mailing-group">Create Mailing Group</div>
        </div>
        <div className="invite-user">Invite User</div>
      </div>
      <div className="search-directory-body">
        <div className="header">
          <div className="project">Project</div>
          <div className="global">Global</div>
        </div>
        <div className="fields">
          <div className="field">
            <div className="col1">
              <div className="row1">
                <div className="name">Organization Name</div>
                <div className="">
                  <input type="text" placeholder="Enter Organization Name" />
                </div>
              </div>
              <div className="row1">
                <div className="name">Division</div>
                <div className="">
                  <input type="text" placeholder="Enter Division" />
                </div>
              </div>
              <div className="row1">
                <div className="name">Given/Group Name</div>
                <div className="">
                  <input type="text" placeholder="Enter Given/Group Name" />
                </div>
              </div>
            </div>
            <div className="col1">
              <div className="row1">
                <div className="name">Family Name</div>
                <div className="">
                  <input type="text" placeholder="Enter Family Name" />
                </div>
              </div>
              <div className="row1" style={{ marginRight: "35%" }}>
                <div className="name">Job Title</div>
                <div className="">
                  <input type="text" placeholder="Enter Job Title" />
                </div>
              </div>
            </div>
          </div>
          <div className="text">Search</div>
        </div>
        <div className="table-container">
          <div className="table-header">
            <table>
              <thead>
                <tr>
                  {headers.map((header, idx) => (
                    <th key={idx}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sampleData.map((row, idx) => (
                  <tr key={idx}>
                    <td className="svg-name-cell">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="none"
                        stroke="#04395f"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M 6.86992 8.6525 C 6.79492 8.645 6.70492 8.645 6.62242 8.6525 C 4.83742 8.5925 3.41992 7.13 3.41992 5.33 C 3.41992 3.4925 4.90492 2 6.74992 2 C 8.58742 2 10.0799 3.4925 10.0799 5.33 C 10.0724 7.13 8.65492 8.5925 6.86992 8.6525 Z"></path>
                        <path d="M 12.3084 3.5 C 13.7634 3.5 14.9334 4.6775 14.9334 6.125 C 14.9334 7.5425 13.8084 8.6975 12.4059 8.75 C 12.3459 8.7425 12.2784 8.7425 12.2109 8.75"></path>
                        <path d="M 3.11906 11.42 C 1.30406 12.635 1.30406 14.615 3.11906 15.8225 C 5.18156 17.2025 8.56406 17.2025 10.6266 15.8225 C 12.4416 14.6075 12.4416 12.6275 10.6266 11.42 C 8.57156 10.0475 5.18906 10.0475 3.11906 11.42 Z"></path>
                        <path d="M 13.7559 15.5 C 14.2959 15.3875 14.8059 15.17 15.2259 14.8475 C 16.3959 13.97 16.3959 12.5225 15.2259 11.645 C 14.8134 11.33 14.3109 11.12 13.7784 11"></path>
                      </svg>
                      <span>{row.usergroup}</span>
                    </td>
                    <td>{row.organization}</td>
                    <td>{row.projectaddress}</td>
                    <td>{row.projectphone}</td>
                    <td>{row.projectfax}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div class="pagination-container">
            <div class="pagination-info">
              <strong>1–13</strong> of 13 Results{" "}
              <span>(0 Selected)</span>
            </div>
            <div class="pagination-controls">
              <button class="page-btn" disabled>
                ‹ Prev
              </button>
              <button class="page-btn active">1</button>
              <button class="page-btn">2</button>
              <button class="page-btn">Next ›</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
